import Entity from '../entity'
export default class Offer extends Entity<number> {
                   startDate: Date = new Date();
                   endDate: Date = new Date();
                   startTime: number;
                   endTime: number;
                   offerPrice: number = 0.0;
                   showPrice: number = 0.0;
                   offerDateTypeId: number = 0;
                   courtId: number = 0;
                   personNumber: number = 1;
                   days: number = 1;
                   payMethod: number = 0;
                   bond: number = 0.0;
                   shadowBond: number = 0;
                   advanceCharge: number = 0.0;
                   shadowAdvanceCharge: number = 0;
                   guestPrice: number = 0;
                   guestBond: number = 0;
                   guestAdvanceCharge: number = 0;
                   notice: string = "";
                   cancelNotice: string = "";
                   needInvoice: boolean = false;
                   isShow: boolean = true;
                   isCopied: boolean = false;
                   courtServices: Array<string> = new Array<string>();
                   courtName: string = "";
                   verifyState: number = 0;
                   _disabled: boolean = false;
                   reduction:  number = 0 ;
                   vipReduction: number | string | any= 0;
                   cashback: number| string | any = 0;
                   cancelDate: number |string = 0;
                   pricePrefix:string | null=null;
               }